import Icon from 'veui/components/Icon'

Icon.register({
  'edit-pencil': {
    paths: [
      {
        d: 'M95.79 704.21a32 32 0 01-32-32L64 512a32 32 0 019.37-22.59l352.71-352.7a32 32 0 0145.25 0l160 160a32 32 0 010 45.25l-352.7 352.67A32 32 0 01256 704l-160.21.21zM128 525.27l-.15 114.9 114.9-.15 320.7-320.73-114.74-114.74zm598.84-278.86a32 32 0 000-45.25l-160-160a32 32 0 00-45.25 45.25l160 160a32 32 0 0045.25 0z'
      }
    ],
    width: '768',
    height: '768'
  }
})
